import * as React from 'react';

import { HANDS_ON_TIME_ICON } from '../lib/placeImage';
import { fetchPhotoUrl } from '../lib/clockLocations';


// Shows the clock icon while loading, or if there is no photo or it can't be loaded.
export default function AuthImage({ path, alt, size = 56 }) {
    const [url, setUrl] = React.useState(null);

    React.useEffect(() => {
        if (!path) return undefined;
        let cancelled = false;
        let created = null;
        fetchPhotoUrl(path).then((objectUrl) => {
            if (cancelled) {
                if (objectUrl) URL.revokeObjectURL(objectUrl);
                return;
            }
            created = objectUrl;
            setUrl(objectUrl);
        });
        return () => {
            cancelled = true;
            if (created) URL.revokeObjectURL(created);
        };
    }, [path]);

    return (
        <img
            src={url || HANDS_ON_TIME_ICON}
            alt={alt}
            style={{ width: size, height: size, objectFit: 'cover', borderRadius: 4, flexShrink: 0 }}
        />
    );
}
